import { useEffect } from 'react'

import { getWindow, useAnalyticsClient } from '@acorns/web-utils'

import { trackLoadingTimeAppReadyForUserInteractionPayload } from 'generated/trackingEvents'

const APP_LOAD_START_ANONYMOUS_ID_STORAGE_KEY = 'app_load_start_anonymous_id'
const APP_LOAD_FINISHED_STORAGE_KEY = 'app_load_finish_logged'
const APP_LOAD_START_TIMESTAMP_STORAGE_KEY = 'app_load_start_timestamp'
const LOADING_TIME_APP_READY_LOGGED_STORAGE_KEY =
  'loading_time_app_ready_logged'

function calculateLoadingTimeAppReadySeconds() {
  const start = parseInt(
    window.sessionStorage.getItem(APP_LOAD_START_TIMESTAMP_STORAGE_KEY) ?? '',
    10,
  )

  if (Number.isInteger(start)) {
    return (Date.now() - start) / 1000
  }

  return null
}

export function TrackAppLoadFinish() {
  const analyticsClient = useAnalyticsClient()

  useEffect(function trackAppLoadFinish() {
    const window = getWindow()

    // To provide a complete apples-to-apples comparison, this event is fired using the
    // same criteria & method as its 'appLoadStart' counterpart in the index.html file.
    if (
      window.crypto &&
      window.crypto.randomUUID &&
      window.navigator.sendBeacon &&
      !window.sessionStorage.getItem(APP_LOAD_FINISHED_STORAGE_KEY)
    ) {
      const anonymousId = window.sessionStorage.getItem(
        APP_LOAD_START_ANONYMOUS_ID_STORAGE_KEY,
      )
      window.navigator.sendBeacon(
        `${process.env.RUDDER_STACK_DATA_PLANE_URL}/beacon/v1/batch?writeKey=${process.env.RUDDER_STACK_WRITE_KEY}`,
        JSON.stringify({
          batch: [
            {
              channel: 'web',
              context: {
                userAgent: window.navigator.userAgent,
              },
              type: 'track',
              anonymousId,
              userId: '',
              event: 'Event Occurred',
              properties: {
                object_name: 'appLoadFinish',
                screen: 'login/',
              },
            },
          ],
        }),
      )
      window.sessionStorage.setItem(APP_LOAD_FINISHED_STORAGE_KEY, 'true')
    }
  }, [])

  useEffect(
    function trackAppLoadTimeToReady() {
      if (
        analyticsClient &&
        !window.sessionStorage.getItem(
          LOADING_TIME_APP_READY_LOGGED_STORAGE_KEY,
        )
      ) {
        const loadingTimeAppReady = calculateLoadingTimeAppReadySeconds()

        if (loadingTimeAppReady) {
          analyticsClient.track(
            ...trackLoadingTimeAppReadyForUserInteractionPayload({
              deltaSeconds: loadingTimeAppReady.toFixed(3),
              screen: 'login/',
            }),
          )
          window.sessionStorage.setItem(
            LOADING_TIME_APP_READY_LOGGED_STORAGE_KEY,
            'true',
          )
        }
      }
    },
    [analyticsClient],
  )

  return null
}
